import React from "react";
import { Button } from "semantic-ui-react";
import ParameterReset1_MAIN from "./ParameterReset1_MAIN";
import ParameterReset2_MAIN from "./ParameterReset2_MAIN";
import ConfirmMacro from "../../../Macros/ConfirmMacro";

const ParameterReset_MAIN = () => {
  const [toggleButton, setToggleButton] = React.useState("1");

  const handleClick = (e, { id }) => {
    setToggleButton(id);
  };

  const renderSwitch = (param) => {
    switch (param) {
      case "1":
        return <ParameterReset1_MAIN />;
      // case '2':
      //     return <ParameterReset2/>;
      default:
        return <ParameterReset1_MAIN />;
    }
  };

  return (
    <div style={styles.div}>
      <Button.Group toggle style={styles.toggle}>
        <Button
          size="medium"
          id="1"
          active={toggleButton === "1"}
          onClick={handleClick}
          content="Parameter Reset Page1"
        />
        {/* <Button
                    size='medium'
                    id='2'
                    active={toggleButton==='2'}
                    onClick={handleClick}
                    content='Parameter Reset Page2'
                /> */}
        <ConfirmMacro option={2} channel={"Set Date/Time"} />
      </Button.Group>
      {renderSwitch(toggleButton)}
    </div>
  );
};

const styles = {
  div: {
    textAlign: "center",
  },
  toggle: {
    marginLeft: "8px",
  },
};

export default ParameterReset_MAIN;
